export default "__VITE_ASSET__CAJRlJVT__"